/*
 * onlyQ High Five auf der Produktseite.
 * Setzt eine dritte Auswahlkarte unter das Appstle Widget: sechs Stueck bestellen,
 * fuenf bezahlen. Klick stellt auf Einzelbestellung und setzt die Menge auf 6.
 * Der eigentliche Abzug passiert ueber den automatischen Rabatt im Warenkorb.
 */
(function () {
  var BUY = 6;
  var PAY = 5;
  var TITEL = 'High Five, 6 Stück für 5';
  var SUB = 'Sechs Stück von diesem Produkt, das sechste ist gratis. Ohne Abo, ohne Laufzeit.';

  var produkt = null;
  var laeuft = false;

  function geld(cents) {
    var t = (cents / 100).toFixed(2).split('.');
    var g = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + g + ',' + t[1];
  }

  function formular() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function mengeFeld() {
    var f = formular();
    var q = f ? f.querySelector('input[name="quantity"]') : null;
    return q || document.querySelector('input[name="quantity"]');
  }

  function variante() {
    var f = formular();
    var el = f ? f.querySelector('[name="id"]') : null;
    return el ? el.value : null;
  }

  function preis() {
    if (!produkt || !produkt.variants || !produkt.variants.length) return null;
    var id = variante();
    var v = null;
    if (id) {
      for (var i = 0; i < produkt.variants.length; i++) {
        if (String(produkt.variants[i].id) === String(id)) { v = produkt.variants[i]; break; }
      }
    }
    if (!v) v = produkt.variants[0];
    return v ? v.price : null;
  }

  function produktLaden(fertig) {
    if (produkt) { fertig(); return; }
    if (laeuft) return;
    laeuft = true;
    var pfad = window.location.pathname.split('?')[0].replace(/\/$/, '');
    fetch(pfad + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { laeuft = false; produkt = j; fertig(); })
      .catch(function () { laeuft = false; });
  }

  function karte() {
    return document.querySelector('[data-oq-hf5]');
  }

  function aktiv(an) {
    var k = karte();
    if (!k) return;
    if (an) { k.classList.add('is-on'); } else { k.classList.remove('is-on'); }
    k.setAttribute('aria-checked', an ? 'true' : 'false');
  }

  function waehlen() {
    var wrap = document.querySelector('.appstle_subscription_wrapper');
    if (wrap) {
      var radios = wrap.querySelectorAll('input[type="radio"]');
      if (radios.length && !radios[0].checked) radios[0].click();
    }
    var q = mengeFeld();
    if (q) {
      q.value = BUY;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }
    aktiv(true);
  }

  function preiseSchreiben() {
    var k = karte();
    if (!k) return;
    var p = preis();
    var jetzt = k.querySelector('[data-hf5-now]');
    var vorher = k.querySelector('[data-hf5-was]');
    if (!jetzt || !vorher) return;
    if (p) {
      jetzt.textContent = geld(p * PAY);
      vorher.textContent = geld(p * BUY);
    } else {
      jetzt.textContent = '';
      vorher.textContent = '';
    }
  }

  function baueKarte() {
    var el = document.createElement('div');
    el.className = 'oq-hf5';
    el.setAttribute('data-oq-hf5', '1');
    el.setAttribute('role', 'radio');
    el.setAttribute('aria-checked', 'false');
    el.setAttribute('tabindex', '0');
    el.innerHTML =
      '<span class="oq-hf5__dot" aria-hidden="true"></span>' +
      '<span class="oq-hf5__main">' +
      '<span class="oq-hf5__t">' + TITEL + '</span>' +
      '<span class="oq-hf5__s">' + SUB + '</span>' +
      '</span>' +
      '<span class="oq-hf5__price"><b data-hf5-now></b><small data-hf5-was></small></span>';
    el.addEventListener('click', waehlen);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); waehlen(); }
    });
    return el;
  }

  function setzen() {
    var wrap = document.querySelector('.appstle_subscription_wrapper');
    if (!wrap || !wrap.parentNode) return;
    if (!karte()) {
      var abo = wrap.parentNode.querySelector('[data-oq-abo="staffel"]');
      if (abo) { wrap.parentNode.insertBefore(baueKarte(), abo); }
      else { wrap.parentNode.insertBefore(baueKarte(), wrap.nextSibling); }
    }
    produktLaden(preiseSchreiben);
    preiseSchreiben();
  }

  function pruefen() {
    var q = mengeFeld();
    if (q && String(q.value) !== String(BUY)) aktiv(false);
  }

  function start() {
    setzen();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === 'quantity' && String(t.value) !== String(BUY)) aktiv(false);
      if (t.name === 'id') preiseSchreiben();
      if (t.type === 'radio' && t.closest && t.closest('.appstle_subscription_wrapper')) {
        var wrap = t.closest('.appstle_subscription_wrapper');
        var radios = wrap.querySelectorAll('input[type="radio"]');
        if (radios[0] !== t) aktiv(false);
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-oq-hf5]')) return;
      window.setTimeout(pruefen, 60);
    }, true);

    if (!document.body || typeof MutationObserver === 'undefined') return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) return;
      timer = window.setTimeout(function () { timer = null; setzen(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
